import reducer from './reducers';

type AppState = ReturnType<typeof reducer>;

export const jobs = (state: AppState) => state.jobs;

export const filterQueue = (state: AppState) => state.searchFilter.stateHistory;
